import Cookies from 'js-cookie';

export const getUTMParams = (): {
	utm_source: string;
	utm_campaign: string;
	utm_medium: string;
	utm_term: string;
	utm_content: string;
} => {
	const params = new URLSearchParams(window.location.search);

	const utmParams = {
		utm_source: params.get('utm_source'),
		utm_campaign: params.get('utm_campaign'),
		utm_medium: params.get('utm_medium'),
		utm_term: params.get('utm_term'),
		utm_content: params.get('utm_content'),
	};

	return utmParams;
};

export const getSourceFromReferrer = () => {
	const referrer = window.document.referrer;

	if (referrer.includes('google.com/search')) {
		return 'Google Organic Search';
	} else if (referrer.includes('google.com/aclk')) {
		return 'Google Ads';
	} else if (referrer.includes('google.com')) {
		return 'Google';
	} else if (referrer.includes('facebook.com')) {
		return 'Facebook';
	} else if (referrer.includes('linkedin.com')) {
		return 'LinkedIn';
		// Using <a> causes the referrer to change from /sign-up. This hack bypasses this condition.
	} else if (referrer === '' || referrer.startsWith(window.location.origin)) {
		return 'Direct';
	} else if (referrer.includes('email')) {
		return 'Email';
	} else {
		return referrer;
	}
};

export const handleUtmParams = () => {
	const existingUTM = JSON.parse(Cookies.get('utm_params') || '{}');
	const hasExistingUTM = !!Object.keys(existingUTM).length;
	const currentUTM = getUTMParams();

	const searchParams = Object.keys(currentUTM);
	const hasSearchParams = searchParams.some((key) => !!currentUTM[key]);

	const shouldUpdate = Object.keys(currentUTM).some(
		(key) => currentUTM[key] && currentUTM[key] !== existingUTM[key]
	);

	const newSource =
		!!existingUTM?.utm_source &&
		existingUTM.utm_source !== currentUTM.utm_source;

	const shouldNotUpdate = !newSource && !hasSearchParams && hasExistingUTM;

	return {
		shouldNotUpdate,
		shouldUpdate,
		existingUTM,
		currentUTM,
		hasExistingUTM,
	};
};

export const pushDataLayer = (event: string) => {
	if (!event) {
		return;
	}

	if (typeof window !== undefined && window.dataLayer) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: event });
		console.log(`[data layer] event: ${event}`);
	} else {
		console.debug('[data layer] no event');
	}
};
